import React from 'react';
import type { FC } from 'react';

import { DateTime } from 'luxon';

import { Button } from '@shared/components/bootstrap';
import { useToggle } from '@shared/hooks/use_toggle';

import { DispatcherRequestDialog } from './dispatcher_request_dialog';
import { canUseDispatcherRequestFlow } from './permissions';

export const DispatcherRequestButton: FC<{
  date: Date;
  regionID: string;
}> = ({ date, regionID }) => {
  const { visible, onToggle } = useToggle();

  if (!canUseDispatcherRequestFlow()) {
    return null;
  }

  return (
    <>
      <Button kind="primary" type="button" onClick={onToggle}>
        Generate Routes
      </Button>
      {visible && <DispatcherRequestDialog date={DateTime.fromJSDate(date)} regionID={regionID} onClose={onToggle} />}
    </>
  );
};
